import styled from "styled-components";

export default styled.img`
	width: ${props => props.width};
	height: ${props => props.height};
	margin: 1rem;
`;
